export const DEPOSIT_TERMS = {
    // ===== متن مخصوص سالن‌دار =====
    marketOwner: {
        title: 'قوانین و مقررات پرداخت بیعانه (سالن‌دار)',
        version: '1.0',
        lastUpdated: '1405/07/26',
        linkText: 'قوانین و مقررات پرداخت بیعانه',
        checkboxText: 'با مطالعه و پذیرش کامل قوانین و مقررات پرداخت بیعانه موافقم.',
        content: `
📋 قوانین و مقررات پرداخت بیعانه — ویژه سالن‌دار

1. کلیات
بیعانه مبلغی است که به منظور قطعی‌سازی رزرو نوبت و جلوگیری از عدم حضور مشتری، توسط مشتری به صورت آنلاین پرداخت می‌شود. این مبلغ پس از انجام کامل خدمات، از مبلغ نهایی صورت‌حساب کسر می‌گردد.

2. شرایط پرداخت
۲-۱. مشتری موظف است حداکثر تا ۱۵ دقیقه پس از ثبت رزرو، مبلغ بیعانه را پرداخت نماید.
۲-۲. در صورت عدم پرداخت در بازه زمانی مشخص‌شده، رزرو به صورت خودکار لغو شده و نوبت به سایر متقاضیان واگذار می‌گردد.

3. شرایط کنسلی و استرداد
۳-۱. در صورت کنسلی رزرو توسط مشتری بیش از 24 ساعت قبل از زمان مقرر، مبلغ بیعانه به کیف پول مشتری بازگردانده می‌شود.
۳-۲. در صورت کنسلی رزرو کمتر از 24 ساعت قبل از زمان مقرر، مبلغ بیعانه به مشتری عودت داده نمی‌شود و به عنوان خسارت به سالن پرداخت می‌گردد.
۳-۳. در صورت عدم حضور مشتری در زمان مقرر (No-Show)، مبلغ بیعانه به هیچ عنوان عودت داده نمی‌شود.
۳-۴. کنسلی رزرو توسط سالن یا سیستم، موجب بازگشت کامل مبلغ بیعانه به کیف پول مشتری می‌گردد.

4. تسویه بیعانه
4-1. پس از انجام خدمات در اولین روز کاری مبالغ بیعانه خدمات انجام شده پس از کسر 2 درصد کمسیون به حساب مدیر سیستم واریز میگردد.

5. استفاده از بیعانه
5-۱. مبلغ بیعانه پس از انجام کامل خدمات، از مبلغ نهایی صورت‌حساب کسر می‌شود.
5-۲. در صورت انصراف مشتری از دریافت بخشی از خدمات، مبلغ بیعانه به نسبت خدمات انجام‌نشده محاسبه و مابقی به کیف پول مشتری بازگردانده می‌شود.

6. اعتبار و انقضا
6-۱. بیعانه پرداخت‌شده تنها برای همان رزرو و در همان تاریخ معتبر است.
6-۲. در صورت عدم مراجعه مشتری، بیعانه منقضی شده و قابل استفاده در رزروهای دیگر نیست.

7. مسئولیت‌ها
7-۱. سالن متعهد است در زمان رزرو، خدمات مورد توافق را با کیفیت مناسب ارائه دهد.
7-۲. در صورت بروز هرگونه مشکل در فرآیند پرداخت، مشتری موظف است مراتب را از طریق پشتیبانی پیگیری نماید.
7-۳. سیستم رزرو نوبت، هیچ‌گونه مسئولیتی در قبال اختلافات ناشی از خدمات ارائه‌شده توسط سالن ندارد و تنها به عنوان واسطه عمل می‌کند.

8. تغییرات قوانین
8-۱. این قوانین ممکن است توسط مدیریت سیستم به‌روزرسانی شود و سالن‌دار موظف به پذیرش نسخه به‌روزرسانی‌شده است.
8-۲. در صورت تغییر قوانین، نسخه جدید در همین صفحه منتشر و تاریخ به‌روزرسانی درج می‌گردد.
    `
    },

    // ===== متن مخصوص مشتری (زمان پرداخت) =====
    customer: {
        title: 'قوانین و مقررات پرداخت بیعانه',
        version: '1.0',
        lastUpdated: '1405/07/26',
        linkText: 'قوانین و مقررات پرداخت بیعانه',
        checkboxText: 'این‌جانب با مطالعه کامل قوانین و مقررات پرداخت بیعانه، ضمن پذیرش شرایط کنسلی و عدم حضور، نسبت به پرداخت مبلغ بیعانه اقدام می‌نمایم.',
        content: `
📋 خلاصه قوانین پرداخت بیعانه

✅ پرداخت: مبلغ بیعانه باید حداکثر ۱۵ دقیقه پس از ثبت رزرو پرداخت شود. در غیر این صورت، رزرو لغو می‌شود.

✅ کنسلی بیش از 24 ساعت قبل: مبلغ بیعانه به کیف پول شما بازگردانده می‌شود.

❌ کنسلی کمتر از 24 ساعت قبل: مبلغ بیعانه عودت داده نمی‌شود.

❌ عدم حضور (No-Show): مبلغ بیعانه عودت داده نمی‌شود.

✅ پس از انجام خدمات: مبلغ بیعانه از صورت‌حساب نهایی کسر می‌شود.

✅ کنسلی توسط سالن: مبلغ بیعانه به کیف پول شما بازگردانده می‌شود.
    `
    }
};

export default DEPOSIT_TERMS;